import React, { PureComponent } from 'react';
import {
  Container,
  BoughtContainer,
  BoughtRow,
  PreviewWrapper,
  LoadingContainer,
  Cover,
  PurchaseModalWrapper,
} from './elements';
import { LoadingIndicator } from '../../atoms/LoadingIndicator';
import { PreviewCard } from '../../molecules/PreviewCard';
import { PreviewCardParams } from '../../organisms/MovieItem/types';
import { BoughtContentsHeader } from '../../organisms/BoughtContentsHeader';
import { BoughtContentTypes } from '../../organisms/BoughtContentsHeader/types';
import { splitArrayIntoGroups } from '../../../utils/arrayUtils';
import { words } from '../../../constants';
import { PurchaseModal } from '../../organisms/PurchaseModal';

type Props = {
  contentTypes: { [key: string]: string };
  title: string;
  selectedType: BoughtContentTypes;
  data: Array<PreviewCardParams>;
  isFetching?: boolean;
  isDownloadingProjectContent?: boolean;
  isDownloadingEAContent?: boolean;
  onSelectContentType: (contentType: BoughtContentTypes) => void;
  onPressCard: (card: PreviewCardParams & { fileURL?: string }) => void;
};

type State = {
  isModalVisible: boolean;
  selectedCard: PreviewCardParams & { fileURL?: string };
  selectedDownloadContent?: string;
  selectedCardId?: string;
  selectDownloadContent?: string;
};

class BoughtContents extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isModalVisible: false,
      selectedCard: {
        thumbnailURL: '',
        title: '',
        points: 0,
        id: '',
        description: '',
        tags: {
          showOnMyPage: false,
          primeContent: false,
          eliteContent: false,
          regularContent: false,
        },
      },
    };
  }

  componentDidUpdate(prevProps: Props) {
    const { isDownloadingProjectContent, isDownloadingEAContent } = this.props;
    const { isModalVisible, selectedCard, selectedCardId } = this.state;

    if (
      isModalVisible &&
      selectedCardId === selectedCard.id &&
      ((prevProps.isDownloadingProjectContent &&
        !isDownloadingProjectContent) ||
        (prevProps.isDownloadingEAContent && !isDownloadingEAContent))
    ) {
      this.onCloseModal();
    }
  }

  handleSelectedCard = (card: PreviewCardParams & { fileURL?: string }) => {
    const { selectedType, onPressCard } = this.props;
    this.setState({ selectedCard: card });
    if (selectedType === 'videos') {
      onPressCard(card);
    } else {
      this.setState({ isModalVisible: true });
    }
  };

  onCloseModal = () => {
    this.setState({ isModalVisible: false });
  };

  redownloadConfirm = () => {
    const { onPressCard } = this.props;
    const { selectedCard } = this.state;
    this.setState({ selectedCardId: selectedCard.id });
    onPressCard(selectedCard);
  };

  render = (): React.ReactElement => {
    const {
      contentTypes,
      title,
      onSelectContentType,
      selectedType,
      data,
      isFetching,
      isDownloadingProjectContent,
      isDownloadingEAContent,
    } = this.props;
    const { isModalVisible } = this.state;
    let formattedData = data ? splitArrayIntoGroups(data, 4) : [];
    return (
      <Container>
        <BoughtContentsHeader
          onPressSelect={onSelectContentType}
          title={title}
          selectedType={selectedType}
          contentTypes={contentTypes}
        />
        <BoughtContainer>
          {isFetching ? (
            <LoadingContainer>
              <LoadingIndicator />
            </LoadingContainer>
          ) : formattedData && formattedData.length > 0 ? (
            formattedData.map(
              (
                data: Array<PreviewCardParams & { fileURL?: string }>,
                index,
              ) => (
                <BoughtRow isFirst={index === 0} key={index}>
                  {data.map((value, innerIndex) => (
                    <PreviewWrapper
                      isFirst={innerIndex === 0}
                      key={value.title}>
                      <PreviewCard
                        imageSource={value.thumbnailURL}
                        title={value.title}
                        points={0}
                        tags={value.tags}
                        id={value.id}
                        description={value.description}
                        onPressCard={this.handleSelectedCard}
                        theme="bought"
                        fileURL={value?.fileURL}
                      />
                    </PreviewWrapper>
                  ))}
                </BoughtRow>
              ),
            )
          ) : (
            words.noPurchasedContent
          )}
        </BoughtContainer>
        <Cover isVisible={isModalVisible}>
          <PurchaseModalWrapper>
            <PurchaseModal
              onPressCancel={this.onCloseModal}
              onPressBuy={this.redownloadConfirm}
              isPurchasingContent={
                isDownloadingProjectContent || isDownloadingEAContent
              }
              isRestricted={false}
              cardData={this.state.selectedCard}
              totalPoints={0}
              isPurchased={true}
            />
          </PurchaseModalWrapper>
        </Cover>
      </Container>
    );
  };
}

export default BoughtContents;
